<template>
    <BaseHero
        class="hero--event hero--event-content"
        :image-credits="image?.credits"
    >
        <template #image>
            <BaseImage
                v-if="image"
                class="base-image--cover"
                v-bind="image"
            />
        </template>

        <template #preTitle>
            <EventDisciplines :disciplines="eventContent.disciplines" />

            <BaseLabel v-if="eventContent.programLine">
                {{ eventContent.programLine }}
            </BaseLabel>
        </template>

        <template #title>
            {{ eventContent.oneLiner }}
        </template>

        <template #description>
            <EventContentMeta class="event-meta--event-detail">
                <template #title>
                    {{ eventContent.title }}
                </template>

                <template
                    v-if="!eventContent.hideArtist"
                    #artists
                >
                    <div class="hero__makers">
                        <EventProductionHouse
                            :production-house="eventContent.productionHouse"
                            :with-comma="!!eventContent.artists?.length"
                        />

                        <EventArtist
                            v-if="eventContent.artists?.length"
                            :artists="eventContent.artists"
                        />
                    </div>
                </template>

                <template #venue>
                    <template
                        v-for="item in eventContent.venues"
                        :key="item.id"
                    >
                        <EventVenueLink
                            :venue="item"
                        />
                    </template>
                </template>
            </EventContentMeta>
        </template>

        <template #events>
            <EventBundleSection
                :event-bundle-query
                color-theme="purple"
                presentation="slider"
            >
                <template #title>
                    Reserveer je ticket
                </template>
            </EventBundleSection>
        </template>
    </BaseHero>
</template>

<script setup lang="ts">
const { eventContent } = defineProps<{
    eventContent: EventContentDetailData;
}>();

const image = computed(() => eventContent.featuredImage);

const eventBundleQuery = computed(() => ({
    __typename: EVENT_BUNDLE_TYPE_CUSTOM as typeof EVENT_BUNDLE_TYPE_CUSTOM,
    eventContent: [eventContent.id]
}));
</script>

<style lang="less" src="~/components/Base/Hero/BaseHero.less" />

<style lang="less">
.hero--event-content .hero__body__inner {
    padding-bottom: 0;
}

.hero--event-content .hero__makers {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0.35em;
}
</style>
